var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-card relative w-full bg-white"},[_c('header',{staticClass:"header flex items-stretch",class:{'bg-black text-light': _vm.headerIsDark}},[_c('span',{staticClass:"flex grow items-center font-bold p-3"},[_vm._t("title")],2)]),_c('div',_vm._b({staticClass:"p-5"},'div',_vm.$attrs,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }